import './Coordinators.css';
import Card from './Card';
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Title from "../Title/Title"
import Team from "./CoordinatorData"
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", width:"20px",height:"20px",margin:"30px"}}
      onClick={onClick}
    />
  );
}


function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block",  width:"20px",height:"20px",zIndex:"1999",margin:"30px"}}
      onClick={onClick}
    />
  );
}
function Coordinator() {
      const settings = {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 1000,
        cssEase: "linear",
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 1320,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 970,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 920,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
          }
        }
      ]
      };
      return (
        <>
    <div id="coordinators-heading" style={{margin: "50px 0"}}>
    <Title title={"Coordinators"}/>
    </div>

        <div className="co-coordinator-container">
    
          <Slider {...settings} className='slider'>
            {Team.map((card, index) => (
              <Card card={card} key={index}/>
            ))}
          </Slider>
        </div>
        </>
      );
}
 

export default Coordinator